module.exports = __webpack_public_path__ + "img/hb-10.34a2c7bd.png";